((myDoc)=>{

    const allEscortsSidebarControls = myDoc.querySelector('.all-escorts-sidebar__controls');
    const galleryToolbar = myDoc.querySelector('.all-escorts-results .gallery-list');
    const galleryFilterDrawer = myDoc.getElementById('galleryFiltersSidebar');
    if (galleryFilterDrawer) {
        const trigger = myDoc.querySelector('[data-bs-target="#galleryFiltersSidebar"]');
        galleryFilterDrawer.addEventListener('show.bs.offcanvas', () => trigger?.setAttribute('aria-expanded', 'true'));
        galleryFilterDrawer.addEventListener('hidden.bs.offcanvas', () => trigger?.setAttribute('aria-expanded', 'false'));
    }

    if (allEscortsSidebarControls && galleryToolbar) {
        const sidebarNodes = [
            galleryFilterDrawer ? null : galleryToolbar.querySelector('.fbar-search-wrap'),
            galleryToolbar.querySelector('.fbar-viewrow')
        ].filter(Boolean);
        const placeholders = sidebarNodes.map((node) => {
            const placeholder = myDoc.createComment(`sidebar-placeholder-${node.className}`);
            node.parentNode.insertBefore(placeholder, node);
            return { node, placeholder };
        });

        let sidebarActive = null;
        const placeGalleryControls = () => {
            const useSidebar = !!galleryFilterDrawer || window.matchMedia('(min-width: 992px)').matches;
            // Only regroup when crossing the breakpoint; tablets fire resize while scrolling.
            if (useSidebar === sidebarActive) return;
            sidebarActive = useSidebar;
            myDoc.querySelectorAll('.dropdown-menu.show').forEach((menu) => menu.classList.remove('show'));
            myDoc.querySelectorAll('[data-bs-toggle="dropdown"][aria-expanded="true"]').forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false');
            });
            placeholders.forEach(({ node, placeholder }) => {
                if (useSidebar) {
                    allEscortsSidebarControls.appendChild(node);
                } else if (placeholder.parentNode) {
                    placeholder.parentNode.insertBefore(node, placeholder.nextSibling);
                }

                node.querySelectorAll('[data-bs-toggle="dropdown"], [data-sidebar-dropdown="true"]').forEach((toggle) => {
                    if (useSidebar) {
                        // Sidebar sections are accordions (closed by default), not Bootstrap dropdowns.
                        toggle.dataset.sidebarDropdown = 'true';
                        toggle.removeAttribute('data-bs-toggle');
                        setSidebarSection(toggle, false);
                    } else {
                        toggle.setAttribute('data-bs-toggle', 'dropdown');
                        toggle.setAttribute('aria-expanded', 'false');
                        delete toggle.dataset.sidebarDropdown;
                    }
                });
            });
        };

        placeGalleryControls();
        window.addEventListener('resize', debounce(placeGalleryControls, 120));

        allEscortsSidebarControls.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-sidebar-dropdown="true"]');
            if (!toggle) return;
            event.preventDefault();
            setSidebarSection(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
        // Show sections that already have a selection (e.g. a URL with ?category=…).
        const openSelectedSections = () => {
            allEscortsSidebarControls.querySelectorAll('[data-sidebar-dropdown="true"]').forEach((toggle) => {
                const menu = toggle.closest('.fbar-dropdown')?.querySelector('.dropdown-menu');
                if (menu && menu.querySelector('input:checked, .fbar-active-row')) setSidebarSection(toggle, true);
            });
        };
        openSelectedSections();
        // common.js marks selected Type/Services rows on DOMContentLoaded (it runs first).
        myDoc.addEventListener('DOMContentLoaded', openSelectedSections);
        myDoc.addEventListener('gallery:filters-hydrated', openSelectedSections);
    }

    function setSidebarSection(toggle, open) {
        const menu = toggle.closest('.fbar-dropdown')?.querySelector('.dropdown-menu');
        if (menu) menu.classList.toggle('show', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // On phones, use the real name search in the Search / Sort / Filter toolbar.
    // On wider screens, keep that same input inside the filter sidebar.
    if (galleryToolbar) {
        const mobileMapLauncher = myDoc.querySelector('.all-escorts-mobile-map');
        const searchWrap = galleryFilterDrawer
            ? myDoc.querySelector('#staffSearchInput')?.closest('.fbar-search-wrap')
            : galleryToolbar.querySelector('.fbar-search-wrap');
        const mobileSearchToggle = searchWrap?.querySelector('.fbar-mobile-search-toggle');
        const searchInput = searchWrap?.querySelector('.fbar-search-input');
        const searchDropdown = searchWrap?.querySelector('#staffDropdown');
        const searchCloseButton = searchDropdown?.querySelector('.btnClose');
        let mapPlaceholder = null;

        const fitMobileNameResults = () => {
            if (!galleryFilterDrawer || !searchDropdown ||
                !galleryToolbar.classList.contains('is-search-open')) return;
            const list = searchDropdown.querySelector('.dropdown-staff-list');
            if (!list || !list.getClientRects().length) return;
            const viewport = window.visualViewport;
            const screenBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight);
            const bar = myDoc.querySelector('.ld-contactbar')?.getBoundingClientRect();
            const safeBottom = bar?.height > 0 ? Math.min(screenBottom, bar.top) : screenBottom;
            const available = Math.max(44, safeBottom - list.getBoundingClientRect().top - 12);
            list.style.setProperty('--staff-results-max-height', `${available}px`);
        };
        const scheduleNameResultsFit = () => window.requestAnimationFrame(fitMobileNameResults);
        searchInput?.addEventListener('focus', scheduleNameResultsFit);
        searchInput?.addEventListener('input', scheduleNameResultsFit);
        galleryToolbar.addEventListener('transitionend', scheduleNameResultsFit);
        window.addEventListener('scroll', scheduleNameResultsFit, { passive: true });
        window.addEventListener('resize', scheduleNameResultsFit);
        window.visualViewport?.addEventListener('resize', scheduleNameResultsFit);
        window.visualViewport?.addEventListener('scroll', scheduleNameResultsFit);

        if (mobileMapLauncher) {
            mapPlaceholder = myDoc.createComment('mobile-map-launcher');
            mobileMapLauncher.parentNode.insertBefore(mapPlaceholder, mobileMapLauncher);
        }

        const placeMobileActions = () => {
            const compact = window.matchMedia('(max-width: 767px)').matches;
            if (!compact) closeMobileSearch();
            if (galleryFilterDrawer && searchWrap) {
                const destination = compact ? galleryToolbar : allEscortsSidebarControls;
                if (destination && searchWrap.parentElement !== destination) {
                    destination.prepend(searchWrap);
                }
            }
            if (mobileMapLauncher) {
                if (compact) {
                    galleryToolbar.appendChild(mobileMapLauncher);
                } else if (mapPlaceholder?.parentNode) {
                    mapPlaceholder.parentNode.insertBefore(mobileMapLauncher, mapPlaceholder.nextSibling);
                }
            }
            if (!compact) {
                galleryToolbar.classList.remove('is-search-open');
                mobileSearchToggle?.setAttribute('aria-expanded', 'false');
            }
        };

        const closeMobileSearch = (returnFocus = false) => {
            if (!galleryToolbar.classList.contains('is-search-open')) return;
            galleryToolbar.classList.remove('is-search-open');
            mobileSearchToggle?.setAttribute('aria-expanded', 'false');
            if (searchDropdown) searchDropdown.style.display = 'none';
            searchInput?.blur();
            if (returnFocus) mobileSearchToggle?.focus();
        };

        mobileSearchToggle?.addEventListener('click', () => {
            const opening = !galleryToolbar.classList.contains('is-search-open');
            galleryToolbar.classList.toggle('is-search-open', opening);
            mobileSearchToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
            if (opening) {
                setTimeout(() => searchInput?.focus(), 80);
            } else if (searchDropdown) {
                searchDropdown.style.display = 'none';
            }
        });

        myDoc.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !galleryToolbar.classList.contains('is-search-open')) return;
            event.preventDefault();
            event.stopPropagation();
            closeMobileSearch(true);
        }, true);

        searchCloseButton?.addEventListener('click', () => closeMobileSearch(true));

        galleryToolbar.addEventListener('click', (event) => {
            if (!galleryToolbar.classList.contains('is-search-open')) return;
            if (event.target.closest('.fbar-search-wrap')) return;
            if (event.target.closest('.fbar-filters-wrap, .gallery-list-dropdown, .all-escorts-mobile-map')) {
                closeMobileSearch();
            }
        });

        placeMobileActions();
        window.addEventListener('resize', debounce(placeMobileActions, 120));
    }

    //price slider start

    // Debounce function
    function debounce(func, wait, immediate) {
        let timeout;
        const debounced = function() {
            const context = this, args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
        debounced.cancel = function() {
            clearTimeout(timeout);
            timeout = null;
        };
        return debounced;
    }

    function initDualRangeSlider(fromSlider, toSlider, fromTooltip, toTooltip, sliderContainer, isPriceSlider) {
        const step = parseInt(fromSlider.step) || 1;
        const minValue = parseInt(fromSlider.min) || 0;
        const maxValue = parseInt(fromSlider.max) || 100;
        const range = maxValue - minValue;

        // Create visual elements
        const trackFill = document.createElement('div');
        trackFill.className = 'slider-track-fill';

        const fromThumb = document.createElement('div');
        fromThumb.className = 'custom-thumb from-thumb';

        const toThumb = document.createElement('div');
        toThumb.className = 'custom-thumb to-thumb';

        const sliderElement = sliderContainer.querySelector('.range-slider');
        sliderElement.appendChild(trackFill);
        sliderElement.appendChild(fromThumb);
        sliderElement.appendChild(toThumb);

        // Hide original inputs but keep them for form submission
        fromSlider.style.display = 'none';
        toSlider.style.display = 'none';

        // Validate and clamp values
        function clampValue(value, min, max) {
            return Math.max(min, Math.min(max, isNaN(value) ? min : value));
        }

        // Update positions and values
        function updateSliderValues(fromValue, toValue) {
            // Clamp and validate values
            fromValue = clampValue(fromValue, minValue, maxValue - step);
            toValue = clampValue(toValue, minValue + step, maxValue);

            // Ensure fromValue <= toValue - step
            if (fromValue > toValue - step) {
                if (activeThumb === fromThumb) {
                    fromValue = toValue - step;
                } else {
                    toValue = fromValue + step;
                }
            }

            // Update slider values
            fromSlider.value = fromValue;
            toSlider.value = toValue;

            // Calculate positions (0-100%)
            const fromPos = ((fromValue - minValue) / range) * 100;
            const toPos = ((toValue - minValue) / range) * 100;

            // Update DOM
            fromThumb.style.left = `${fromPos}%`;
            toThumb.style.left = `${toPos}%`;
            trackFill.style.left = `${fromPos}%`;
            trackFill.style.width = `${toPos - fromPos}%`;

            // Update tooltips (with NaN protection)
            fromTooltip.textContent = isPriceSlider ? `£${fromValue}` : fromValue;
            toTooltip.textContent = isPriceSlider ? `£${toValue}` : toValue;
        }

        // Track active thumb
        let activeThumb = null;

        // Handle thumb dragging
        function setupThumbDrag(thumb, isFrom) {
            let isDragging = false;
            let startX = 0;
            let startLeft = 0;

            thumb.addEventListener('mousedown', startDrag);
            thumb.addEventListener('touchstart', startDrag);

            function startDrag(e) {
                isDragging = true;
                activeThumb = thumb;
                thumb.style.zIndex = '4';

                const clientX = e.clientX || (e.touches && e.touches[0].clientX);
                startX = clientX;
                startLeft = parseFloat(thumb.style.left) || (isFrom ? 0 : 100);

                document.addEventListener('mousemove', moveHandler);
                document.addEventListener('touchmove', moveHandler, { passive: false });
                document.addEventListener('mouseup', stopDrag);
                document.addEventListener('touchend', stopDrag);

                e.preventDefault();
                e.stopPropagation();
            }

            function moveHandler(e) {
                if (!isDragging) return;

                const clientX = e.clientX || (e.touches && e.touches[0].clientX);
                const rect = sliderElement.getBoundingClientRect();
                const deltaX = clientX - startX;
                const percentageDelta = (deltaX / rect.width) * 100;

                let newPosition = startLeft + percentageDelta;
                newPosition = clampValue(newPosition, 0, 100);

                const value = Math.round(minValue + (newPosition / 100) * range);

                if (isFrom) {
                    updateSliderValues(value, parseInt(toSlider.value));
                    toSlider.dispatchEvent(new Event('input'));
                } else {
                    updateSliderValues(parseInt(fromSlider.value), value);
                    fromSlider.dispatchEvent(new Event('input'));
                }

                e.preventDefault();
            }

            function stopDrag() {
                isDragging = false;
                activeThumb = null;
                thumb.style.zIndex = '3';

                document.removeEventListener('mousemove', moveHandler);
                document.removeEventListener('touchmove', moveHandler);
                document.removeEventListener('mouseup', stopDrag);
                document.removeEventListener('touchend', stopDrag);
            }
        }

        // Handle track clicks
        sliderElement.addEventListener('click', (e) => {
            // Ignore thumb clicks
            if (e.target.classList.contains('custom-thumb') || activeThumb) {
                return;
            }

            const rect = sliderElement.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const clickPos = (clickX / rect.width) * 100;
            const clickValue = clampValue(
                Math.round(minValue + (clickPos / 100) * range),
                minValue,
                maxValue
            );

            const fromValue = parseInt(fromSlider.value);
            const toValue = parseInt(toSlider.value);

            // Determine which thumb to move
            if (Math.abs(clickValue - fromValue) < Math.abs(clickValue - toValue)) {
                // Move from thumb (ensure it doesn't violate min gap)
                updateSliderValues(
                    Math.min(clickValue, toValue - step),
                    toValue

                );
                toSlider.dispatchEvent(new Event('input'));
            } else {
                // Move to thumb (ensure it doesn't violate min gap)
                updateSliderValues(
                    fromValue,
                    Math.max(clickValue, fromValue + step)
                );
                fromSlider.dispatchEvent(new Event('input'));
            }
        });

        // Initialize drag for both thumbs
        setupThumbDrag(fromThumb, true);
        setupThumbDrag(toThumb, false);

        // Initialize positions with validation
        updateSliderValues(
            clampValue(parseInt(fromSlider.value), minValue, maxValue - step),
            clampValue(parseInt(toSlider.value), minValue + step, maxValue)
        );

        // Dispatch initial events
        // const event = new Event('input', { bubbles: true });
        // fromSlider.dispatchEvent(event);
        // toSlider.dispatchEvent(event);
    }

    // Sliders are initialized lazily in initFilterPanel() once the
    // offcanvas filter body has been fetched and injected on first open.

    //price slider end ----------------------

    var reachMax = false;
    var docHeight = 0;
    var staffRequestInFlight = false;
    var activeStaffRequest = null;
    var sort = '';
    var borough = [];
    var prices = [];
    var ages = [];
    var busts = [];
    var dresses = [];
    var nationality = [];
    var hair_colour = [];
    var fetishes = [];
    var toys = [];
    var all_fetishes = [];
    var services = [];
    var location = '';
    var location_call_mode = myDoc.querySelector('input[name="location_call_mode"]:checked')?.value || 'outcall';
    var incall_location = [];
    var category = [];
    var property = '';
    var available = '';
    var oldpricemin = null;
    var oldpricemax = null;
    var oldagemin = null;
    var oldagemax = null;
    let filterInput =  myDoc.querySelectorAll('.filter-list input');
    const galleryRow = myDoc.querySelector('.gallery-row'); // Use querySelector
    const galleryLoadMoreWrap = myDoc.querySelector('#galleryLoadMoreWrap');
    const galleryLoadMoreBtn = myDoc.querySelector('#galleryLoadMoreBtn');
    const directoryPagination = myDoc.querySelector('#directoryPagination');
    const directoryPerPage = Number.parseInt(directoryPagination?.dataset.perPage || '', 10);
    let directoryAjaxMode = false;
    // Query string of the last history entry filter.js created (see popstate below).
    let lastDirectorySearch = window.location.search;
    const rememberDirectorySearch = () => { lastDirectorySearch = window.location.search; };
    let restoringHistory = false;
    let directoryCurrentPage = Number.parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10) || 1;
    const directoryKeys = ['sort', 'borough', 'prices', 'ages', 'busts', 'nationality',
        'hair_colour', 'fetishes', 'toys', 'all_fetishes', 'services', 'location_call_mode',
        'incall_location', 'category', 'dresses', 'available'];
    // Filter and sort choices are kept out of the address bar; only ?page=N is written.
    // Incoming links that already carry filter params still restore them on load.
    function directoryUrl(page = directoryCurrentPage) {
        const url = new URL(window.location.href);
        directoryKeys.forEach(key => url.searchParams.delete(key));
        if (page > 1) url.searchParams.set('page', String(page));
        else url.searchParams.delete('page');
        return url;
    }
    function hasDirectorySelections() {
        const selections = [sort, borough, prices, ages, busts, nationality, hair_colour,
            fetishes, toys, all_fetishes, services, incall_location, category, dresses, available];
        return selections.some(value => Array.isArray(value) ? value.length > 0 : !!value)
            || (!!locationdiv && location_call_mode === 'incall');
    }
    let galleryCurrentPage = Number.parseInt(galleryLoadMoreWrap?.dataset.currentPage || '1', 10);
    const galleryNextOffset = Number.parseInt(galleryLoadMoreWrap?.dataset.nextOffset || '', 10);
    if (Number.isFinite(galleryNextOffset)) {
        start = galleryNextOffset;
    }
    const allEscortsCta = myDoc.querySelector('#allEscortsGalleryCta');
    const allEscortsCtas = myDoc.querySelectorAll('#allEscortsGalleryCta, .allEscortsGalleryCta');
    const counter = myDoc.querySelector('.counter');
    const tcounter = myDoc.querySelector('.t_count');
    const locationdiv = myDoc.querySelector('div.location');
    const categorydiv = myDoc.querySelector('div.category');
    const propertydiv = myDoc.querySelector('div.property');
    const servicediv = myDoc.querySelector('div.service');
    const clearFilters = myDoc.querySelectorAll('.clear_filter');
    // Recommended slider section (location pages). Its card IDs are excluded
    // from the default infinite-scroll batches; any filter/sort interaction
    // clears the exclusion so filtered results cover everyone. The section
    // itself stays visible — it is editorial content, not part of the grid.
    const incallSection = myDoc.querySelector('#incallSection');
    var excludeIds = incallSection ? (incallSection.dataset.exclude || '') : '';
    function hideIncallSection() {
        excludeIds = '';
    }
    const clearSort = myDoc.querySelector('.clear-sorting-btn');
    const availableInp = myDoc.querySelector('input.available');
    //const loader = myDoc.querySelector('.loader');

    const dataType = sessionStorage.getItem('type');
    const dataValue = sessionStorage.getItem('type_value');
    const dataLabel = sessionStorage.getItem('type_label');

    if(counter && parseInt(counter.innerHTML) <13 ){
        reachMax = true;
    }

    const handleInput = (e) => {
        let inputName = e.target.name;
        if (e.target.type === 'checkbox' && inputName) {
            myDoc.querySelectorAll(`input[name="${inputName}"]`).forEach(input => {
                if (input !== e.target && input.value === e.target.value) {
                    input.checked = e.target.checked;
                }
            });
        }
        // let id = e.target.id;
        // let labelElement = document.querySelector(`label[for="${e.target.id}"]`);
        // let label = '';
        // let exiting_avl = '';

        // if (labelElement) {
        //     label = labelElement.innerHTML; // Get the innerHTML of the label
        // }

        if (e.target.classList.contains('location-call-mode')) {
            location_call_mode = e.target.value === 'incall' ? 'incall' : 'outcall';
        }
        // if (e.target.classList.contains('available')) {
        //     if(e.target.checked){
        //         available = e.target.value;
        //     }else{
        //         available = '';
        //     }
        //     if(available == 1){
        //         document.querySelector('#away').checked = false;
        //         exiting_avl = filterItems.querySelector(`li[data-id="away"]`);
        //     }else{
        //         document.querySelector('#available').checked = false;
        //         exiting_avl = filterItems.querySelector(`li[data-id="available"]`);
        //     }
        // }
        // if (e.target.classList.contains('gender')) {
        //     genders = getArrayInputValues(inputName);
        // }
        if (e.target.classList.contains('price')) {
            const scope = e.target.closest('[data-gallery-facet]') || document;
            const minInput = scope.querySelector('input[name="price_min"]');
            const maxInput = scope.querySelector('input[name="price_max"]');
            let priceMin = Number(minInput.value || minInput.min || 0);
            let priceMax = Number(maxInput.value || maxInput.max || 1000);
            if (priceMin > priceMax) return;
            prices = [priceMin, priceMax];
            //console.log(price);
        }

        if (e.target.classList.contains('age')) {
            const scope = e.target.closest('[data-gallery-facet]') || document;
            const minInput = scope.querySelector('input[name="age_min"]');
            const maxInput = scope.querySelector('input[name="age_max"]');
            let ageMin = Number(minInput.value || minInput.min || 18);
            let ageMax = Number(maxInput.value || maxInput.max || 99);
            if (ageMin > ageMax) return;
            ages = [ageMin, ageMax];
            //console.log(ages);
        }
        if (e.target.classList.contains('bust')) {
            busts = getArrayInputValues(inputName);
        }
        // Smart Filter can change several facets during one debounce window.
        // Read every supported facet, not just the final event's input name.
        services = getArrayInputValues('service[]');
        incall_location = getArrayInputValues('incall_location[]');
        category = getArrayInputValues('category[]');
        dresses = getArrayInputValues('dress[]');
        hair_colour = getArrayInputValues('hair_colour[]');
        nationality = getArrayInputValues('nationality[]');
        // if (e.target.classList.contains('toy')) {
        //     toys = getArrayInputValues(inputName);
        // }
        // if (e.target.classList.contains('wardrobe')) {
        //     wardrobes = getArrayInputValues(inputName);
        // }
        if (e.target.classList.contains('fetish')) {
            fetishes = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('toy')) {
            toys = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('fetish-all')) {
            all_fetishes = getArrayInputValues(inputName);
        }

        hideIncallSection();
        galleryRow.innerHTML = ``;

        start = 0;
        reachMax = false;
        docHeight = 0;
        getStaff('loadingActive');
        updateFilterButton();
    };

    // Keep at least ~2 viewport-heights of cards rendered below the fold. Fires on
    // scroll AND again right after each batch lands (see getStaff success handler),
    // so batches chain until the buffer is full and the user never sees a load gap —
    // by the second-last row the next batch is already in the DOM.
    function maybeLoadMore() {
        if (!galleryRow) { return; }
        const remaining = galleryRow.getBoundingClientRect().bottom - window.innerHeight;
        if (remaining < Math.max(1600, window.innerHeight * 2) && docHeight < 1) {
            docHeight = 1;
            getStaff();
        }
    }

    // Location and selected category pages retain their manual, capped View More
    // interaction. All Escorts uses the route-specific sentinel below without a cap.
    const viewMoreBtn = myDoc.querySelector('#viewMoreBtn');
    const viewMoreWrap = myDoc.querySelector('#viewMoreWrap');
    const usesTwentyCardBatches = categorydiv
        && ['busty-escorts', 'dominatrix-escorts'].includes(window.location.pathname.split('/').filter(Boolean).pop());
    const VIEW_MORE_CAP = usesTwentyCardBatches
        ? 60
        : (categorydiv || servicediv || locationdiv)
            ? Number.MAX_SAFE_INTEGER
            : 50;
    function updateViewMoreBtn() {
        if (!viewMoreWrap) { return; }
        if (reachMax || start >= VIEW_MORE_CAP) {
            viewMoreWrap.style.display = 'none';
        } else {
            viewMoreWrap.style.display = '';
        }
    }
    if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', function () {
            if (reachMax || start >= VIEW_MORE_CAP) { return; }
            getStaff();
        });
        updateViewMoreBtn();
    }

    function galleryPageUrl(page) {
        const url = new URL(window.location.href);
        if (page > 1) {
            url.searchParams.set('page', page);
        } else {
            url.searchParams.delete('page');
        }
        return url;
    }

    function renderDirectoryPagination(count) {
        if (!directoryPagination) return;
        const lastPage = Math.ceil(Number(count) / directoryPerPage);
        directoryPagination.hidden = lastPage < 2;
        if (lastPage < 2) {
            directoryPagination.innerHTML = '';
            return;
        }
        directoryCurrentPage = Math.min(directoryCurrentPage, lastPage);
        const mobilePages = new Set([
            1, lastPage,
            ...Array.from({ length: Math.min(3, lastPage) }, (_, i) => directoryCurrentPage + i - 1)
                .filter(page => page >= 1 && page <= lastPage)
        ]);
        let previous = 0;
        const controls = [];
        const button = (page, label, extra = '') =>
            `<a class="directory-pagination__link ${extra}" href="${directoryUrl(page)}" data-page="${page}" aria-label="${label}" ${page === directoryCurrentPage ? 'aria-current="page"' : ''}>${label}</a>`;
        if (directoryCurrentPage > 1) controls.push(button(directoryCurrentPage - 1, 'Previous'));
        for (let page = 1; page <= lastPage; page++) {
            const showOnMobile = mobilePages.has(page);
            if (showOnMobile && page > previous + 1) controls.push('<span class="directory-pagination__gap d-lg-none" aria-hidden="true">…</span>');
            const extra = [
                page === directoryCurrentPage ? 'is-current' : '',
                showOnMobile ? '' : 'd-none d-lg-inline-flex'
            ].filter(Boolean).join(' ');
            controls.push(button(page, String(page), extra));
            if (showOnMobile) previous = page;
        }
        if (directoryCurrentPage < lastPage) controls.push(button(directoryCurrentPage + 1, 'Next'));
        directoryPagination.innerHTML = controls.join('');
    }

    directoryPagination?.addEventListener('click', function (event) {
        const control = event.target.closest('[data-page]');
        if (!control || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!directoryAjaxMode) return; // Initial links are real, reloadable pages.
        event.preventDefault();
        const page = Number.parseInt(control.dataset.page, 10);
        if (!Number.isFinite(page) || page === directoryCurrentPage) return;
        directoryCurrentPage = page;
        start = (page - 1) * directoryPerPage;
        reachMax = false;
        galleryRow.innerHTML = '';
        getStaff('loadingActive', true);
        // Back to the top of the gallery (its heading on the homepage), not just the cards.
        (galleryRow.closest('[data-gallery-top]') || galleryRow).scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    function updateGalleryLoadMoreStatus(state) {
        if (!galleryLoadMoreWrap || !galleryLoadMoreBtn) { return; }
        const message = galleryLoadMoreBtn.querySelector('.gallery-load-more__message');
        const isLoading = state === 'loading';
        galleryLoadMoreWrap.classList.toggle('is-loading', isLoading);
        galleryLoadMoreWrap.classList.toggle('is-error', state === 'error');
        galleryLoadMoreBtn.classList.toggle('disabled', isLoading);
        galleryLoadMoreBtn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        if (message) {
            message.textContent = isLoading
                ? 'Loading more escorts…'
                : state === 'complete'
                    ? 'All escorts have been loaded.'
                    : state === 'error'
                        ? 'Try Loading More Escorts Again'
                        : 'Load More Escorts';
        }
        if (state === 'complete') {
            galleryLoadMoreWrap.hidden = true;
        } else {
            galleryLoadMoreWrap.hidden = false;
            galleryLoadMoreBtn.href = galleryPageUrl(galleryCurrentPage + 1).toString();
        }
    }

    if (galleryLoadMoreWrap && galleryLoadMoreBtn) {
        const initialTotal = Number.parseInt(counter?.textContent || '', 10);
        if (Number.isFinite(initialTotal) && initialTotal <= start) {
            reachMax = true;
            updateGalleryLoadMoreStatus('complete');
        } else {
            updateGalleryLoadMoreStatus('idle');
        }
        galleryLoadMoreBtn.addEventListener('click', function (event) {
            event.preventDefault();
            if (reachMax || staffRequestInFlight) { return; }
            getStaff();
        });
    }

    if (galleryRow && !directoryPagination && !viewMoreBtn && !galleryLoadMoreWrap && !allEscortsCta) { // Homepage uses its bounded preview and links to the complete gallery.
        window.addEventListener('scroll', maybeLoadMore, { passive: true });
    }

    function updateAllEscortsCta(count) {
        if (!allEscortsCta) { return; }

        const params = new URLSearchParams();
        if (incall_location.length) params.set('incall_location', incall_location.join(','));
        if (services.length) params.set('services', services.join(','));
        if (category.length) params.set('category', category.join(','));

        const galleryUrl = allEscortsCta.dataset.galleryUrl || '/gallery/';
        const hasSelections = incall_location.length > 0 || services.length > 0 || category.length > 0;
        const href = hasSelections ? `${galleryUrl}?${params.toString()}` : galleryUrl;
        const label = hasSelections && Number.isFinite(Number(count))
            ? `Show ${Number(count)} ${Number(count) === 1 ? 'Escort' : 'Escorts'}`
            : 'See all London Escorts';

        allEscortsCtas.forEach(function (cta) {
            cta.href = href;
            cta.textContent = label;
        });
    }

    function insertAllEscortsCta(count) {
        updateAllEscortsCta(count);
    }
    insertAllEscortsCta();

    function getStaff(addremoveClass = null, replacePage = false) {
        //console.log(addremoveClass);

        // Page's own category (type pages) is sent separately as base_category
        // so it is ANDed server-side with any checked type filters (Natural/
        // Enhanced etc.) instead of OR-merged into the same list.
        var base_category = categorydiv ? categorydiv.innerHTML : '';

        if(propertydiv && !property.includes(propertydiv.innerHTML)){
            property = propertydiv.innerHTML;
        }

        var base_service = servicediv ? servicediv.innerHTML : '';

        if(locationdiv && !location.includes(locationdiv.innerHTML)){
            location = locationdiv.innerHTML;
        }

        if (prices.includes(oldpricemax) && prices.includes(oldpricemin)) {
            prices = [];
        }

        if (ages.includes(oldagemax) && ages.includes(oldagemin)) {
            ages = [];
        }

        const isResetRequest = start === 0 || replacePage;
        // A filtered page number would reopen unfiltered after a refresh, so filtered
        // results keep the clean URL.
        const directoryRequestUrl = directoryPagination
            ? directoryUrl(replacePage && !hasDirectorySelections() ? directoryCurrentPage : 1) : null;
        const isHistoryRestore = restoringHistory;
        const requestLimit = directoryPagination ? directoryPerPage : viewMoreBtn
            ? Math.min(limit, Math.max(0, VIEW_MORE_CAP - start))
            : limit;
        if (staffRequestInFlight) {
            if (!isResetRequest) {
                return false;
            }
            activeStaffRequest?.abort();
        }

        if (isResetRequest) {
            if (directoryPagination) {
                directoryAjaxMode = true;
                if (!replacePage) {
                    directoryCurrentPage = 1;
                }
                directoryPagination.hidden = true;
            }
            galleryCurrentPage = 1;
            if (galleryLoadMoreWrap) {
                window.history.replaceState({}, '', galleryPageUrl(1)); rememberDirectorySearch();
                updateGalleryLoadMoreStatus('idle');
            }
        }

        if (reachMax) {
            return false;
        } else {
            staffRequestInFlight = true;
            const staffRequest = 'AbortController' in window
                ? new AbortController()
                : { abort: function () {}, signal: undefined };
            let staffRequestFailed = false;
            activeStaffRequest = staffRequest;
            galleryRow.classList.add('loading');
            updateGalleryLoadMoreStatus('loading');
            //loader.classList.remove('d-none');
            addremoveClass && galleryRow.classList.remove(addremoveClass);

            fetch(filterUrl, { // Use fetch API
                method: 'POST',
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded', // Important for POST data
                'X-CSRF-TOKEN': csrfToken // Add CSRF token if needed
                },
                body: new URLSearchParams({ // Use URLSearchParams for form data
                    limit: requestLimit,
                    skip: start,
                    sort: sort,
                    borough: borough,
                    prices: prices,
                    ages: ages,
                    busts: busts,
                    property: property,
                    nationality: nationality,
                    hair_colour: hair_colour,
                    fetishes: fetishes,
                    toys: toys,
                    all_fetishes: all_fetishes,
                    services: services,
                    base_service: base_service,
                    location: location,
                    location_call_mode: location_call_mode,
                    incall_location: incall_location,
                    category: category,
                    base_category: base_category,
                    show_bust_size: categorydiv && categorydiv.dataset.showBustSize === '1' ? '1' : '0',
                    category_tag_context: categorydiv ? categorydiv.dataset.categoryTagContext || '' : '',
                    dresses: dresses,
                    available: available,
                    exclude: excludeIds
                }),
                signal: staffRequest.signal,
            })
            .then(response => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                myDoc.querySelector('[data-gallery-results-error]')?.remove();
                return response.json();
            })
            .then(list => {
                if (activeStaffRequest !== staffRequest) { return; }
                //console.log(list);

                // if (loader) {
                //     loader.classList.add('d-none'); // Remove loader
                // }


                if (list && typeof list.html === 'string' && list.html.trim() !== '') {
                    let cnt = list.count ?? 0;
                    //console.log(galleryRow);
                    galleryRow.insertAdjacentHTML('beforeend', list.html); // Use insertAdjacentHTML
                    insertAllEscortsCta(cnt);
                    document.dispatchEvent(new CustomEvent('gallery:cards-updated'));
                    if (counter) counter.innerHTML = list.count;
                    if (directoryPagination) renderDirectoryPagination(cnt);
                    if (directoryRequestUrl && window.location.href !== directoryRequestUrl.href && !isHistoryRestore) {
                        window.history.pushState({}, '', directoryRequestUrl); rememberDirectorySearch();
                    }
                    if (tcounter) {
                        tcounter.innerHTML = cnt > 1 ? `${cnt} Available Escorts` : `${cnt} Available Escort`;
                        tcounter.classList.remove('d-none');
                        tcounter.classList.add('active', 'bg-favourite');
                    }
                    start += requestLimit;
                    docHeight = 0;
                    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
                        new bootstrap.Tooltip(el);
                    });
                    if (galleryLoadMoreWrap) {
                        var loadMoreGridTotal = cnt - (excludeIds ? excludeIds.split(',').filter(Boolean).length : 0);
                        if (start >= loadMoreGridTotal) {
                            reachMax = true;
                            updateGalleryLoadMoreStatus('complete');
                        } else {
                            if (!isResetRequest) {
                                galleryCurrentPage += 1;
                                window.history.replaceState({}, '', galleryPageUrl(galleryCurrentPage)); rememberDirectorySearch();
                            }
                            updateGalleryLoadMoreStatus('idle');
                        }
                    } else if (viewMoreBtn) {
                        // Button mode (location pages): never chain batches automatically.
                        // The server count includes the recommended-slider models that the
                        // grid excludes — subtract them so the button hides exactly when
                        // the grid itself is exhausted (no dead final click).
                        var gridTotal = cnt - (excludeIds ? excludeIds.split(',').filter(Boolean).length : 0);
                        if (start >= gridTotal) { reachMax = true; }
                        updateViewMoreBtn();
                    } else if (!directoryPagination && !allEscortsCta) {
                        // Top the buffer back up immediately (batches chain until
                        // ~2 viewport-heights of cards sit below the fold).
                        maybeLoadMore();
                    }
                } else {
                    if (start < 1) {
                        galleryRow.innerHTML = `
                            <div class="col-lg-12">
                                <div class="text-center fs-4 py-4 my-5">
                                    <div class="fs-1 lh-1"><i class="fa-thin fa-face-disappointed"></i></div>
                                    <div class="fs-1 lh-1 pb-3">No matches found</div>
                                    We couldn't find anyone matching your filters. Try adjusting or clearing them to see more escorts.
                                </div>
                            </div>
                        `;
                        if (counter) counter.innerHTML = 0;
                        if (tcounter) {
                            tcounter.innerHTML = `No Available Escort`;
                            tcounter.classList.remove('d-none');
                            tcounter.classList.remove('active', 'bg-favourite');
                        }
                        insertAllEscortsCta(0);
                        document.dispatchEvent(new CustomEvent('gallery:cards-updated'));
                    }
                    reachMax = true;
                    if (directoryPagination) renderDirectoryPagination(0);
                    if (directoryRequestUrl && window.location.href !== directoryRequestUrl.href && !isHistoryRestore) {
                        window.history.pushState({}, '', directoryRequestUrl); rememberDirectorySearch();
                    }
                    updateViewMoreBtn();
                    updateGalleryLoadMoreStatus('complete');
                    return false;
                }
            })
            .catch(error => {
                if (error.name === 'AbortError') { return; }
                staffRequestFailed = true;
                if (!myDoc.querySelector('[data-gallery-results-error]')) {
                    const message = myDoc.createElement('div');
                    message.dataset.galleryResultsError = 'true';
                    message.className = 'alert alert-warning w-100';
                    message.setAttribute('role', 'alert');
                    message.textContent = 'Could not load the results. ';
                    const retry = myDoc.createElement('button');
                    retry.type = 'button';
                    retry.className = 'btn btn-sm btn-outline-secondary';
                    retry.textContent = 'Retry';
                    retry.addEventListener('click', () => getStaff('loadingActive', true));
                    message.append(retry);
                    galleryRow.before(message);
                }
                console.error("Error fetching data:", error); // Handle errors
                updateGalleryLoadMoreStatus('error');
            })
            .finally(() => {
                if (activeStaffRequest !== staffRequest) { return; }
                //console.log("Fetch completed");
                //loader.classList.add('d-none');
                staffRequestInFlight = false;
                activeStaffRequest = null;
                galleryRow.classList.remove('loading');
                addremoveClass && galleryRow.classList.add(addremoveClass);
            });
        }
    }


    function updateFilterButton() {
        const filterBtn = myDoc.querySelector('.gallery-list-filterBtn');
        if (!filterBtn) { return; }

        if((category.length < 1 || (categorydiv && category.length == 1)) && (services.length < 1 || (servicediv && services.length == 1)) && services.length < 1 && borough.length < 1 && (prices.length < 1 || (prices[1] == oldpricemax && prices[0] == oldpricemin)) && (ages.length < 1 || (ages[1] == oldagemax && ages[0] == oldagemin)) && busts.length < 1 && nationality.length < 1 && hair_colour.length < 1 && dresses.length < 1 && fetishes.length < 1 && toys.length < 1 && all_fetishes.length < 1 && available == ''){
            console.log('No filters applied');
            if(filterBtn.classList.contains('bg-favourite', 'text-white', 'f600')){
                filterBtn.classList.remove('bg-favourite', 'text-white', 'f600');
                filterBtn.classList.add('bg-transparent', 'text-default', 'f400');
            }
        }
        else if(filterBtn.classList.contains('bg-transparent', 'text-default', 'f400')){
            filterBtn.classList.remove('bg-transparent', 'text-default', 'f400');
            filterBtn.classList.add('bg-favourite', 'text-white', 'f600');
        }
    }


    // The "available" toggle lives in the lazy-loaded filter panel; its
    // change handler is attached in initFilterPanel().


    const getArrayInputValues = (inputName) => {
        const inputElements = myDoc.querySelectorAll(`input[name="${inputName}"]`);
        let filterval = [];
        inputElements.forEach(input => {
            if (input.checked) {
                if (!filterval.includes(input.value)) {
                    filterval.push(input.value);
                }
            }
        });
        //console.log(filterval);
        return filterval;
    }

    const debouncedInputHandler = debounce(handleInput, 500);

    function restoreDirectoryControls() {
        if (!directoryPagination) return;
        const params = new URLSearchParams(window.location.search);
        const values = key => (params.get(key) || '').split(',').filter(Boolean);
        const checkboxNames = { services: 'service[]', incall_location: 'incall_location[]',
            category: 'category[]', busts: 'busts[]', dresses: 'dress[]',
            nationality: 'nationality[]', hair_colour: 'hair_colour[]',
            fetishes: 'fetishes[]', toys: 'toys[]', all_fetishes: 'all_fetishes[]' };
        Object.entries(checkboxNames).forEach(([key, name]) => {
            const selected = values(key);
            myDoc.querySelectorAll('input').forEach(input => {
                if (input.name === name) input.checked = selected.includes(input.value);
            });
        });
        sort = params.get('sort') || '';
        myDoc.querySelectorAll('input[name="sortby"]').forEach(input => {
            input.checked = input.value === sort;
        });
        const selectedSort = myDoc.querySelector('input[name="sortby"]:checked');
        const sortLabel = myDoc.querySelector('.fbar-sort-label');
        if (sortLabel) sortLabel.textContent = selectedSort
            ? (myDoc.querySelector(`label[for="${selectedSort.id}"]`)?.textContent.trim() || 'Sort by')
            : 'Sort by';
        myDoc.querySelector('.gallery-list-dropdown > a')?.classList.toggle('fbar-active', !!selectedSort);
        myDoc.querySelector('.clear-sorting-block')?.classList.toggle('d-none', !selectedSort);
        const mode = params.get('location_call_mode') === 'incall' ? 'incall' : 'outcall';
        myDoc.querySelectorAll('input[name="location_call_mode"]').forEach(input => {
            input.checked = input.value === mode;
        });
        location_call_mode = mode;
        borough = values('borough');
        prices = values('prices');
        ages = values('ages');
        const ageFrom = myDoc.querySelector('.fbar-age-from');
        const ageTo = myDoc.querySelector('.fbar-age-to');
        if (ageFrom && ageTo) {
            ageFrom.value = ages.length === 2 ? ages[0] : ageFrom.options[0].value;
            ageTo.value = ages.length === 2 && ages[1] !== '99'
                ? ages[1] : ageTo.options[ageTo.options.length - 1].value;
        }
        busts = values('busts');
        dresses = values('dresses');
        nationality = values('nationality');
        hair_colour = values('hair_colour');
        fetishes = values('fetishes');
        toys = values('toys');
        all_fetishes = values('all_fetishes');
        services = values('services');
        incall_location = values('incall_location');
        category = values('category');
        available = params.get('available') === '1' ? '1' : '';
        myDoc.querySelectorAll('input.available').forEach(input => { input.checked = available === '1'; });
        const ranges = { prices: ['price_min', 'price_max'], ages: ['age_min', 'age_max'] };
        Object.entries(ranges).forEach(([key, names]) => {
            const selected = values(key);
            names.forEach((name, index) => {
                const input = myDoc.querySelector(`input[name="${name}"]`);
                if (input) input.value = selected.length === 2 ? selected[index] : (index ? input.max : input.min);
            });
        });
        directoryCurrentPage = Math.max(1, Number.parseInt(params.get('page') || '1', 10) || 1);
        updateFilterButton();
    }

    restoreDirectoryControls();
    services = getArrayInputValues('service[]');
    incall_location = getArrayInputValues('incall_location[]');
    category = getArrayInputValues('category[]');

    window.clearGalleryFacet = key => {
        const setters = {
            services: () => { services = []; }, category: () => { category = []; },
            incall_location: () => { incall_location = []; }, hair_colour: () => { hair_colour = []; },
            nationality: () => { nationality = []; }, dresses: () => { dresses = []; },
            busts: () => { busts = []; }, prices: () => { prices = []; }, ages: () => { ages = []; },
            fetishes: () => { fetishes = []; }, toys: () => { toys = []; }, all_fetishes: () => { all_fetishes = []; }
        };
        if (!setters[key]) return;
        setters[key]();
        const names = { services: 'service[]', category: 'category[]', incall_location: 'incall_location[]',
            dresses: 'dress[]', busts: 'busts[]', fetishes: 'fetishes[]', toys: 'toys[]', all_fetishes: 'all_fetishes[]' };
        myDoc.querySelectorAll('input[type="checkbox"]').forEach(input => {
            if (input.name === (names[key] || `${key}[]`)) input.checked = false;
        });
        hideIncallSection();
        galleryRow.innerHTML = '';
        start = 0;
        reachMax = false;
        getStaff('loadingActive');
        updateFilterButton();
    };

    // Only react to real filter/page history entries. A same-page "#" change (e.g. an
    // in-page link) also fires popstate and must not reload the gallery.
    window.addEventListener('popstate', () => {
        if (!directoryPagination) return;
        if (window.location.search === lastDirectorySearch) return;
        rememberDirectorySearch();
        debouncedInputHandler.cancel();
        restoreDirectoryControls();
        restoringHistory = true;
        directoryAjaxMode = true;
        start = (directoryCurrentPage - 1) * directoryPerPage;
        reachMax = false;
        galleryRow.innerHTML = '';
        getStaff('loadingActive', true);
        restoringHistory = false;
    });
    myDoc.addEventListener('input', function (event) {
        if (event.target.matches('.filter-list input')) {
            debouncedInputHandler(event);
        }
    });

    const addRemoveActiveOnclick = (ele) => {
        if(ele) {
            let targetEle = myDoc.querySelector(ele),
            actinArray = targetEle.querySelectorAll('li'),
            clearBorough = targetEle.querySelector('.btn-clearBorough');
            let hasActive = false;
            //let clearBorough = myDoc.querySelector(ele);
            actinArray.forEach(i => {
                i.addEventListener('click', (e)=> {
                    e.target.classList.toggle('active');
                    if(e.target.classList.contains('active')){
                        borough.push(i.dataset.slug);
                    }else{
                        borough = borough.filter(s => s !== i.dataset.slug);
                    }
                    galleryRow.innerHTML = ``;
                    start = 0;
                    reachMax = false;
                    docHeight = 0;
                    //console.log(borough)
                    getStaff();

                    hasActive = Array.from(actinArray).some(item => item.classList.contains('active'));
                    //console.log(hasActive);
                    hasActive?clearBorough.classList.remove('d-none'):clearBorough.classList.add('d-none');

                })
            })

            clearBorough.addEventListener('click', (e) => {
                actinArray.forEach(item => {
                    item.classList.contains('active')?item.classList.remove('active'):null;
                });
                setTimeout(()=>{e.target.classList.add('d-none')}, 100)
                galleryRow.innerHTML = ``;
                start = 0;
                reachMax = false;
                docHeight = 0;
                borough = [];
                //console.log(borough)
                getStaff();
            })
        }
    }
    //addRemoveActiveOnclick('.dropdown-borough')

    if (dataType && dataValue && dataLabel) {
        // let checkOpt = document.getElementById(dataLabel+'-'+dataValue);
        // if(checkOpt){
        //     checkOpt.click();
        // }

        sessionStorage.removeItem('type');
        sessionStorage.removeItem('type_value');
        sessionStorage.removeItem('type_label');
    }

    if(clearSort){
        clearSort.addEventListener('click', () => {
            const srtOption = myDoc.querySelectorAll(`input[type="radio"]`);
            srtOption.forEach(input => {
                input.checked = false;
            });
            const clearSortBox = myDoc.querySelector('.clear-sorting-block');
            const sortBtn = myDoc.querySelector('.gallery-list-dropdown a');
            if (sortBtn) {
                sortBtn.classList.remove('bg-favourite', 'text-white', 'f600');
                sortBtn.classList.add('bg-transparent', 'text-default', 'f400');
            }
            if (clearSortBox) {
                clearSortBox.classList.add('d-none');
            }
            const dismissBtn = document.querySelector('button[data-bs-dismiss="offcanvas"]');
            if (dismissBtn) dismissBtn.click();
            sort = '';
            hideIncallSection();
            galleryRow.innerHTML = '';
            start = 0;
            reachMax = false;
            docHeight = 0;
            getStaff('loadingActive');
        });
    }
    // Clear all filters

    clearFilters.forEach((clearFilter) => clearFilter.addEventListener('click', () => {
        // Prevent a recently toggled filter's delayed handler from running after
        // Reset and reapplying stale UI or issuing an extra request.
        debouncedInputHandler.cancel();

        const checkInput = myDoc.querySelectorAll(`input[type="checkbox"]`);
        //const sortList = '';
        hideIncallSection();
        galleryRow.innerHTML = '';
        checkInput.forEach(input => {
            if (input.checked) {
                input.checked = false;
            }
        });

        // const srtOption = myDoc.querySelectorAll(`input[type="radio"]`);
        // srtOption.forEach(input => {
        //     input.checked = false;
        // });

        // Reset price slider values
        const fromSlider = document.getElementById('fromSlider');
        const toSlider = document.getElementById('toSlider');
        const panelLoaded = !!(fromSlider && toSlider);

        if (panelLoaded) {

        // Temporarily remove event listeners to prevent duplicate AJAX calls
        const oldFromSliderClone = fromSlider.cloneNode(true);
        const oldToSliderClone = toSlider.cloneNode(true);
        fromSlider.parentNode.replaceChild(oldFromSliderClone, fromSlider);
        toSlider.parentNode.replaceChild(oldToSliderClone, toSlider);

        document.querySelector('input[name="price_min"]').value = oldpricemin;
        document.querySelector('input[name="price_max"]').value = oldpricemax;
        document.querySelector('input[name="price_min"]').setAttribute('min', oldpricemin);
        document.querySelector('input[name="price_min"]').setAttribute('max', oldpricemax);
        document.querySelector('input[name="price_max"]').setAttribute('min', oldpricemin);
        document.querySelector('input[name="price_max"]').setAttribute('max', oldpricemax);

        // Reset price slider visual representation
        if (oldFromSliderClone && oldToSliderClone) {
            const priceContainer = document.querySelector('.range_price');
            if (priceContainer) {
                const trackFill = priceContainer.querySelector('.slider-track-fill');
                const fromThumb = priceContainer.querySelector('.from-thumb');
                const toThumb = priceContainer.querySelector('.to-thumb');

                if (trackFill && fromThumb && toThumb) {
                    const range = parseInt(oldToSliderClone.max) - parseInt(oldFromSliderClone.min);
                    const fromPos = ((oldpricemin - parseInt(oldFromSliderClone.min)) / range) * 100;
                    const toPos = ((oldpricemax - parseInt(oldFromSliderClone.min)) / range) * 100;

                    fromThumb.style.left = `${fromPos}%`;
                    toThumb.style.left = `${toPos}%`;
                    trackFill.style.left = `${fromPos}%`;
                    trackFill.style.width = `${toPos - fromPos}%`;

                    const fromTooltip = document.getElementById('fromSliderTooltip');
                    const toTooltip = document.getElementById('toSliderTooltip');
                    if (fromTooltip && toTooltip) {
                        fromTooltip.textContent = `£${oldpricemin}`;
                        toTooltip.textContent = `£${oldpricemax}`;
                    }
                }
            }
        }
        }

        // Reset age slider values
        if (panelLoaded) {
        const fromAgeSlider = document.getElementById('fromAgeSlider');
        const toAgeSlider = document.getElementById('toAgeSlider');

        // Temporarily remove event listeners to prevent duplicate AJAX calls
        const oldFromAgeSliderClone = fromAgeSlider.cloneNode(true);
        const oldToAgeSliderClone = toAgeSlider.cloneNode(true);
        fromAgeSlider.parentNode.replaceChild(oldFromAgeSliderClone, fromAgeSlider);
        toAgeSlider.parentNode.replaceChild(oldToAgeSliderClone, toAgeSlider);

        document.querySelector('input[name="age_min"]').value = oldagemin;
        document.querySelector('input[name="age_max"]').value = oldagemax;
        document.querySelector('input[name="age_min"]').setAttribute('min', oldagemin);
        document.querySelector('input[name="age_min"]').setAttribute('max', oldagemax);
        document.querySelector('input[name="age_max"]').setAttribute('min', oldagemin);
        document.querySelector('input[name="age_max"]').setAttribute('max', oldagemax);

        // Reset age slider visual representation
        if (oldFromAgeSliderClone && oldToAgeSliderClone) {
            const ageContainer = document.querySelector('.range_age');
            if (ageContainer) {
                const ageTrackFill = ageContainer.querySelector('.slider-track-fill');
                const ageFromThumb = ageContainer.querySelector('.from-thumb');
                const ageToThumb = ageContainer.querySelector('.to-thumb');

                if (ageTrackFill && ageFromThumb && ageToThumb) {
                    const ageRange = parseInt(oldToAgeSliderClone.max) - parseInt(oldFromAgeSliderClone.min);
                    const ageFromPos = ((oldagemin - parseInt(oldFromAgeSliderClone.min)) / ageRange) * 100;
                    const ageToPos = ((oldagemax - parseInt(oldFromAgeSliderClone.min)) / ageRange) * 100;

                    ageFromThumb.style.left = `${ageFromPos}%`;
                    ageToThumb.style.left = `${ageToPos}%`;
                    ageTrackFill.style.left = `${ageFromPos}%`;
                    ageTrackFill.style.width = `${ageToPos - ageFromPos}%`;

                    const fromAgeTooltip = document.getElementById('fromAgeSliderTooltip');
                    const toAgeTooltip = document.getElementById('toAgeSliderTooltip');
                    if (fromAgeTooltip && toAgeTooltip) {
                        fromAgeTooltip.textContent = oldagemin;
                        toAgeTooltip.textContent = oldagemax;
                    }
                }
            }
        }
        }

        const dismissBtn = document.querySelector('button[data-bs-dismiss="offcanvas"]');
        if (dismissBtn) dismissBtn.click();
        // sort = '';
        prices = [];
        nationality = [];
        hair_colour = [];
        busts = [];
        fetishes = [];
        toys = [];
        all_fetishes = [];
        services = [];
        location = '';
        location_call_mode = 'outcall';
        const outcallMode = myDoc.querySelector('input[name="location_call_mode"][value="outcall"]');
        if (outcallMode) outcallMode.checked = true;
        incall_location = [];
        category = [];
        dresses = [];
        ages = [];
        reachMax = false;
        start = 0;

        // Only call getStaff once
        getStaff('loadingActive');
        updateFilterButton();

        // Re-initialize sliders after a short delay to ensure proper event handling
        if (panelLoaded) {
        setTimeout(() => {
            // Price slider
            initDualRangeSlider(
                document.getElementById('fromSlider'),
                document.getElementById('toSlider'),
                document.getElementById('fromSliderTooltip'),
                document.getElementById('toSliderTooltip'),
                document.querySelector('.range_price'),
                true
            );

            // Age slider
            initDualRangeSlider(
                document.getElementById('fromAgeSlider'),
                document.getElementById('toAgeSlider'),
                document.getElementById('fromAgeSliderTooltip'),
                document.getElementById('toAgeSliderTooltip'),
                document.querySelector('.range_age'),
                false
            );
        }, 100);
        }
    }));

    if (tcounter) tcounter.addEventListener("click", function(e){
        if(tcounter.classList.contains('active')){
            const dismissBtn = document.querySelector('button[data-bs-dismiss="offcanvas"]');
            if (dismissBtn) dismissBtn.click();
        }
    });

    myDoc.querySelectorAll(`input[name="sortby"]`).forEach((radio) => {
        radio.addEventListener("change", function (e) {

            sort = e.target.value;
            hideIncallSection();
            galleryRow.innerHTML = ``;
            start = 0;
            reachMax = false;
            docHeight = 0;
            console.log(e.target.value);
            getStaff('loadingActive');

            const clearSortBox = myDoc.querySelector('.clear-sorting-block');
            const sortBtn = myDoc.querySelector('.gallery-list-dropdown a');
            if (clearSortBox) {
                clearSortBox.classList.remove('d-none');
            }
            if (sortBtn) {
                sortBtn.classList.remove('bg-transparent', 'text-default', 'f400');
                sortBtn.classList.add('bg-favourite', 'text-white', 'f600');
            }
        });
    });

    // ── Lazy-load the advanced-filter offcanvas body on first open ──────────
    function initFilterPanel() {
        const offcanvasBody = document.querySelector('#offcanvasFilter .offcanvas-body');
        if (!offcanvasBody) return;
        if (directoryPagination) {
            // The URL no longer carries filters, so tick the panel from the current selections.
            const selectedByName = { 'service[]': services, 'category[]': category,
                'incall_location[]': incall_location, 'busts[]': busts, 'bust[]': busts, 'dress[]': dresses,
                'nationality[]': nationality, 'hair_colour[]': hair_colour, 'fetishes[]': fetishes,
                'toys[]': toys, 'all_fetishes[]': all_fetishes };
            offcanvasBody.querySelectorAll('input[type="checkbox"]').forEach(input => {
                input.checked = (selectedByName[input.name] || []).map(String).includes(input.value);
            });
            const avail = offcanvasBody.querySelector('input.available');
            if (avail) avail.checked = available === '1';
            const ranges = { prices: ['price_min', 'price_max'], ages: ['age_min', 'age_max'] };
            Object.entries(ranges).forEach(([key, names]) => {
                const selected = (key === 'prices' ? prices : ages).map(String);
                if (selected.length !== 2) return;
                names.forEach((name, i) => {
                    const input = offcanvasBody.querySelector(`input[name="${name}"]`);
                    if (input) input.value = selected[i];
                });
            });
        }

        // Initialize price slider
        const fs = document.getElementById('fromSlider');
        const ts = document.getElementById('toSlider');
        if (fs && ts) {
            initDualRangeSlider(
                fs,
                ts,
                document.getElementById('fromSliderTooltip'),
                document.getElementById('toSliderTooltip'),
                document.querySelector('.range_price'),
                true
            );
        }

        // Initialize age slider
        const fas = document.getElementById('fromAgeSlider');
        const tas = document.getElementById('toAgeSlider');
        if (fas && tas) {
            initDualRangeSlider(
                fas,
                tas,
                document.getElementById('fromAgeSliderTooltip'),
                document.getElementById('toAgeSliderTooltip'),
                document.querySelector('.range_age'),
                false
            );
        }

        // Capture default slider bounds for "Clear all"
        const pmin = document.querySelector('input[name="price_min"]');
        const pmax = document.querySelector('input[name="price_max"]');
        const amin = document.querySelector('input[name="age_min"]');
        const amax = document.querySelector('input[name="age_max"]');
        if (pmin) oldpricemin = pmin.min;
        if (pmax) oldpricemax = pmax.max;
        if (amin) oldagemin = amin.min;
        if (amax) oldagemax = amax.max;

        // Attach input listeners to the freshly injected filter fields
        offcanvasBody.querySelectorAll('.filter-list input').forEach(item => {
            item.addEventListener('input', debouncedInputHandler);
        });

        // "Available now" toggle
        const avail = offcanvasBody.querySelector('input.available');
        if (avail) {
            avail.addEventListener('change', (e) => {
                available = e.target.checked ? e.target.value : '';
                hideIncallSection();
                galleryRow.innerHTML = ``;
                start = 0;
                reachMax = false;
                docHeight = 0;
                getStaff('loadingActive');
                updateFilterButton();
            });
        }
    }

    const offcanvasFilterEl = document.getElementById('offcanvasFilter');
    let filterPanelLoadPromise = null;
    function ensureGalleryFilterPanel() {
        const container = document.getElementById('filterFieldsContainer');
        if (!container) return Promise.resolve();
        if (container.dataset.loaded === '1' && container.querySelector('.filter-form')) return Promise.resolve();
        if (filterPanelLoadPromise) return filterPanelLoadPromise;

        const url = container.dataset.optionsUrl;
        const params = new URLSearchParams({ context: container.dataset.context || 'normal' });
        if (document.querySelector('[data-gallery-options]')) params.set('on_demand', '1');
        if (container.dataset.type) {
            params.set('type', container.dataset.type);
            params.set('type_value', container.dataset.typeValue || '');
            params.set('type_label', container.dataset.typeLabel || '');
        }

        container.dataset.loaded = '1';
        filterPanelLoadPromise = fetch(url + '?' + params.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.text();
            })
            .then(html => {
                container.innerHTML = html;
                initFilterPanel();
            })
            .catch(err => {
                container.dataset.loaded = '0';
                container.innerHTML = '<div class="text-center py-4 text-muted small" role="alert">Could not load filters. <button type="button" class="btn btn-sm btn-outline-secondary" data-retry-filter-panel>Retry</button></div>';
                console.error('Filter options load failed:', err);
                throw err;
            })
            .finally(() => {
                filterPanelLoadPromise = null;
            });

        return filterPanelLoadPromise;
    }

    window.ensureGalleryFilterPanel = ensureGalleryFilterPanel;
    if (offcanvasFilterEl) {
        offcanvasFilterEl.addEventListener('show.bs.offcanvas', function () {
            ensureGalleryFilterPanel().catch(() => {});
        });
    }

    // ── Active filter chips above the gallery ("Chelsea ×", "Blonde ×", Clear all) ──
    // Built from the selected checkboxes, so every filter source (sidebar, drawer,
    // smart filter, URL) is covered. Removing a chip unticks it through the normal
    // filter flow, so results, badges and the URL update as usual.
    (() => {
        const bar = myDoc.querySelector('[data-active-filters]');
        if (!bar) return;
        const text = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();
        const proxyFor = (input) => {
            if (input.classList.contains('category')) return myDoc.querySelector(`.fbar-cat-proxy[data-category-id="${CSS.escape(input.value)}"]`);
            if (input.classList.contains('service')) return myDoc.querySelector(`.fbar-svc-proxy[data-service-id="${CSS.escape(input.value)}"]`);
            return null;
        };
        const labelFor = (input) => {
            if (input.classList.contains('incall-location')) return text(input.closest('li')?.querySelector('.fbar-check-text'));
            if (input.classList.contains('category') || input.classList.contains('service')) {
                const attr = input.classList.contains('category') ? 'data-category-id' : 'data-service-id';
                return text(myDoc.querySelector(`[${attr}="${CSS.escape(input.value)}"] .fbar-check-text`));
            }
            if (input.classList.contains('available')) return 'Available now';
            return input.dataset.smartLabel
                || text(input.id ? myDoc.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null)
                || input.value;
        };
        const removeFilter = (input) => {
            const proxy = proxyFor(input);
            if (proxy) { proxy.click(); return; } // keeps the Type/Services badges in sync
            input.checked = false;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        const chip = (label, onClick, extraClass = '') => {
            const button = myDoc.createElement('button');
            button.type = 'button';
            button.className = `gallery-active-filter ${extraClass}`.trim();
            button.addEventListener('click', onClick);
            return button;
        };
        const render = () => {
            const seen = new Set();
            const chips = [];
            myDoc.querySelectorAll('.filter-list input[type="checkbox"]:checked, input.available:checked').forEach((input) => {
                const label = labelFor(input);
                const key = `${input.classList[0] || ''}|${input.className}|${input.value}`;
                if (!label || seen.has(key)) return;
                seen.add(key);
                const button = chip(label, () => { removeFilter(input); schedule(); });
                button.setAttribute('aria-label', `Remove filter: ${label}`);
                button.append(label);
                const x = myDoc.createElement('span');
                x.className = 'gallery-active-filter__x';
                x.setAttribute('aria-hidden', 'true');
                x.textContent = '×';
                button.append(x);
                chips.push(button);
            });
            if (chips.length > 1) {
                const clearAll = chip('Clear all', () => { myDoc.querySelector('.clear_filter')?.click(); schedule(); }, 'gallery-active-filter--clear');
                clearAll.textContent = 'Clear all';
                chips.push(clearAll);
            }
            bar.replaceChildren(...chips);
            bar.hidden = chips.length === 0;
        };
        let queued = false;
        const schedule = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(() => { queued = false; render(); });
        };
        ['input', 'change', 'click', 'gallery:cards-updated', 'gallery:filters-hydrated', 'DOMContentLoaded']
            .forEach((type) => myDoc.addEventListener(type, schedule));
        render();
    })();

})(document);
